import { useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ClipLoader } from "react-spinners";
import { useSelector } from "react-redux";

import axios from "../../utils/helpers/axios";
import Input from "../../components/Input/Input";
import Select from "../../components/Input/SelectInput";
import Button from "../../components/Button/Button";
import { attorniesColumn } from "../../constants/TableColumns/Columns";
import Table from "../../components/Table/Table";
import Header from "../../components/Header/Header";
import Pagination from "../../components/Pagination/Pagination";
import { ToggleSidebarContext } from "../../components/Layout/Layout";

import AddIcon from "../../assets/svg/addIcon";
import SearchIcon from "../../assets/svg/searchIcon";
import AttorniesIcon from "../../assets/svg/attorniesIcon";

export default function Attornies() {
  const { user } = useSelector((store) => store.auth);
  const { setToggleSidebar } = useContext(ToggleSidebarContext);
  const navigate = useNavigate();

  const [attorneys, setAttorneys] = useState([]);
  const [totalAttorneys, setTotalAttorneys] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [searchQuery, setSearchQuery] = useState("");
  const [filterFields, setFilterFields] = useState({
    field: "",
    value: "",
  });
  const [communities, setCommunities] = useState([]);
  const [community, setCommunity] = useState();
  const [isLoading, setIsLoading] = useState(false);

  const onChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleChange = (id, data) => {
    setCommunity(data);
    setFilterFields({
      field: "communitiesAllowed",
      value: data._id,
    });
  };

  const getAttorneyData = async () => {
    try {
      setIsLoading(true);

      const { data } = await axios.get(
        `/api/company/attorneys?pageNum=${currentPage}&rowsPerPage=${rowsPerPage}&sortFields=updatedAt&sortOrders=-1&${
          filterFields.field
            ? "filterFields=" +
              filterFields.field +
              "&filterValues=" +
              filterFields.value +
              "&"
            : ""
        }${searchQuery ? "searchQuery=" + searchQuery : ""}`
      );

      if (data.success) {
        setAttorneys(data.attorneys);
        setTotalAttorneys(data.matchedAttorneysCount);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const getCommunities = async () => {
    try {
      setIsLoading(true);

      const { data } = await axios.get(
        "/api/community?&sortFields=updatedAt&sortOrders=-1"
      );

      if (data.success) {
        setCommunities(data.communities);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getAttorneyData();
  }, [currentPage, rowsPerPage, filterFields.value]);

  useEffect(() => {
    setCurrentPage(1);
  }, [rowsPerPage]);

  useEffect(() => {
    if (searchQuery.length === 0) getAttorneyData();
    if (searchQuery.length > 2) getAttorneyData();
  }, [searchQuery]);

  useEffect(() => {
    getCommunities();
  }, []);

  return (
    <div className="w-full">
      <Header
        Icon={AttorniesIcon}
        title="Attorney"
        buttonText={user?.company?.companyName}
        onClick={() => {
          navigate("/companydashboard");
        }}
      />
      <div
        onClick={() => setToggleSidebar(false)}
        className="px-8 flex flex-col gap-4 h-[92%] mt-4"
      >
        <div className="flex gap-4">
          <div className="grow flex gap-4">
            <Input
              iconClass="absolute top-[22%] left-4 text-secondary-gray"
              Icon={SearchIcon}
              placeholder="Search Attorney by Name"
              inputFieldClass="placeholder:text-primary-gray"
              outerClass="w-[60%]"
              onChange={(e) => onChange(e)}
              extraClass="relative w-full border-gray border-[1px] py-[0.1rem] rounded-full px-12"
            />
            <Select
              iconClass="absolute top-[22%] left-2 text-secondary-gray"
              placeholder="Select Community"
              inputFieldClass="placeholder:text-primary-gray"
              outerClass="w-[40%]"
              dropdownData={communities}
              id="community"
              fieldName="letterName"
              handleChange={handleChange}
              value={community?.letterName}
              extraClass="relative w-full border-gray border-[1px] py-[0.1rem] rounded-full px-4"
            />
          </div>

          <Link to="/company/add-attornies">
            <Button
              Icon={AddIcon}
              iconClass="w-[1rem] h-[1rem]"
              extraClass="relative text-primary-white bg-primary-teal py-2 px-4 text-sm rounded-full"
              innerText="Add New Attorney"
            />
          </Link>
        </div>

        <div className=" overflow-auto min-h-[6rem] max-h-[82%] flex justify-center">
          {isLoading && <ClipLoader color={"#0080A2"} size={50} />}
          {!isLoading && attorneys.length !== 0 && (
            <Table
              pageSize={rowsPerPage}
              COLUMNS={attorniesColumn}
              tableData={attorneys}
            />
          )}
          {!isLoading && attorneys.length === 0 && (
            <div className="flex justify-center text-primary-gray">
              No attorney found
            </div>
          )}
        </div>

        <Pagination
          isStatic={false}
          currentPage={currentPage}
          totalCount={totalAttorneys}
          pageSize={rowsPerPage}
          onPageChange={(page) => {
            setCurrentPage(page);
          }}
        />
        <Pagination
          isStatic={true}
          currentPage={rowsPerPage}
          onPageChange={(rowsPerPage) => {
            setRowsPerPage(rowsPerPage);
          }}
        />
      </div>
    </div>
  );
}
